export default "__VITE_ASSET__f4fef056__"